import React, { useState, useEffect } from "react";
import Card from "./Card/Card";
import Bitcou from "../../lib/Bitcou";

const FeaturedCards = ({handleAddCart, country }) => { 
  const [brands, setBrands] = useState([]);
  

  const fetchProducts = async () => {
    let products = await Bitcou.getFeaturedBrands(3, country)
    setBrands(products) 
  };

  useEffect(() => {
    fetchProducts();  
  }, [country]);

  if(!brands.length) return <></>;

  return (
    <div className="featured-gifts ">
      <div className="section-head">
        <h3 className="section-title mb-5">Featured gift cards</h3>
        <p>A quick look at some of the most popilar brands</p>
      </div>

      <div className="section-body mb-5">
        <div className="features-list">
        {brands.map((brand) => (
          <Card key={brand.id} brand={brand} handleAddToCart={handleAddCart}/> 
        ))}
          
        </div>
      </div>
    </div>
  );
};

export default FeaturedCards;
